import { adminFetch } from "./_client";
import type { FeatureFlag, FeatureFlagAnalytics } from "./types";


export function fetchFeatureFlags(token: string) {
  return adminFetch<{ flags: FeatureFlag[] }>("/admin/feature-flags", token);
}


export function createFeatureFlag(token: string, data: Partial<FeatureFlag>) {
  return adminFetch<{ flag: FeatureFlag }>("/admin/feature-flags", token, {
    method: "POST",
    body: JSON.stringify(data),
  });
}


export function updateFeatureFlag(token: string, id: number, data: Partial<FeatureFlag>) {
  return adminFetch<{ flag: FeatureFlag }>(`/admin/feature-flags/${id}`, token, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}


// Upsert by flag_key — used for declared flags that have no DB row yet
// (id === null). Creates the row on first write, updates it thereafter.
export function upsertFeatureFlagByKey(token: string, flagKey: string, data: Partial<FeatureFlag>) {
  return adminFetch<{ flag: FeatureFlag }>(`/admin/feature-flags/by-key/${encodeURIComponent(flagKey)}`, token, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}


export function deleteFeatureFlag(token: string, id: number) {
  return adminFetch<{ success: boolean }>(`/admin/feature-flags/${id}`, token, {
    method: "DELETE",
  });
}


export function fetchFeatureFlagAnalytics(token: string, id: number, period?: string) {
  const params = period ? `?period=${period}` : "";
  return adminFetch<FeatureFlagAnalytics>(`/admin/feature-flags/${id}/analytics${params}`, token);
}
